export const environment = {
  production: true,
  preview: false,
  siteURL: 'https://www.ahome.com.tw',
  firebase: {
    apiKey: 'AIzaSyC61qCEUC33DkRWwws4qkG37T1StkfJPj0',
    authDomain: 'orange-house-20251123.firebaseapp.com',
    projectId: 'orange-house-20251123',
    storageBucket: 'orange-house-20251123.firebasestorage.app',
    messagingSenderId: '100606190304',
    appId: '1:100606190304:web:df49e16645ec8caefca685',
  },
  geocodingKey: 'AIzaSyChtFKZtsJD9SddgrHC798277jCPXghbkE',
  fbPageId: '100083525340824',
  fbAppId: '101115609238001',
  awoo: {
    url: 'https://api.awoo.org/nununi',
    id: 2204912200,
    token: 'cfe8206976cd4d9ccd4314c5f4aebbb3a1e6dbe0',
  },
};
